import * as core from '../../../../../../../core'

import { query } from './terms-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.conditions.widgets.terms-table',
    description: 'Terms and Conditions',
    name: 'Terms and Conditions',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
